import { baseApi } from './baseApi';

export const categoriesApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getCategories: builder.query({
      query: (queryString = '') => ({
        url: queryString ? `category/list?${queryString}` : 'category/list',
        method: 'GET',
      }),
      providesTags: ['Categories'],
    }),

    getCategoriesSelect: builder.query({
      query: () => ({
        url: 'category/select',
        method: 'GET',
      }),
      providesTags: ['Categories'],
    }),

    getCategoriesForContent: builder.query({
      query: () => ({
        url: 'category/selectforcontent',
        method: 'GET',
      }),
      providesTags: ['Categories'],
    }),

    getCategory: builder.query({
      query: (id) => ({
        url: `category/get/${id}`,
        method: 'GET',
      }),
      providesTags: (result, error, id) => [{ type: 'Categories', id }],
    }),

    createCategory: builder.mutation({
      query: (body) => ({
        url: 'category/create',
        method: 'POST',
        body: JSON.stringify(body),
        headers: {
          'Content-Type': 'application/json',
        },
      }),
      invalidatesTags: ['Categories'],
    }),

    updateCategory: builder.mutation({
      query: (body) => ({
        url: 'category/update',
        method: 'PUT',
        body: JSON.stringify(body),
        headers: {
          'Content-Type': 'application/json',
        },
      }),
      invalidatesTags: (result, error, body) => [
        { type: 'Categories', id: body?.id },
        'Categories',
      ],
    }),

    deleteCategory: builder.mutation({
      query: (id) => ({
        url: `category/delete/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Categories'],
    }),
  }),
});

export const {
  useGetCategoriesQuery,
  useGetCategoriesSelectQuery,
  useGetCategoriesForContentQuery,
  useGetCategoryQuery,
  useCreateCategoryMutation,
  useUpdateCategoryMutation,
  useDeleteCategoryMutation,
} = categoriesApi;

